import RenderHTML from '../../ui-components/RenderHTML'

export const BackButton = ({ onBack }: { onBack: () => void }) => {
  return (
    <div onClick={onBack}>
      <RenderHTML innerHTMLText={BACK_BUTTON} />
    </div>
  )
}

const BACK_BUTTON = `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#187BC9"/>
<g clip-path="url(#clip0_8755_6969)">
<path d="M24.8964 18L11.1016 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.3461 13.753L11.1016 17.9976L15.3461 22.2422" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8755_6969">
<rect width="16" height="16" fill="white" transform="translate(10 26) rotate(-90)"/>
</clipPath>
</defs>
</svg>`
